import md5 from "md5"

export default ({locale, messages}) => {
  return `${locale}${md5(JSON.stringify(messages))}`
}
